import { baseClient } from '@/api/client'
import { PivotTable } from '@/pages/dashboard/entities/pivotTable'

export async function getPivotTable(key: string) {
    return await baseClient.get<PivotTable>(`/ajax/pivot-table/${key}`)
}
